import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly options: ReadonlyArray<{ readonly value: string; readonly label: string }> | null;
};

const KindFilter: React.FC<Props> = ({ options }) => {
	const filters = useEffectiveWorkflowRunFilters();

	const handleKindChange = React.useCallback((kind: string | null) => {
		setWorkflowRunFilters(workflowRunFiltersSignal.peek().setKind(kind));
	}, []);

	return (
		<Dropdown<string>
			name="workflowRunKind"
			label="Type de traitement"
			placeholder="Tous les types"
			options={[...(options ?? [])]}
			optionLabel="label"
			optionValue="value"
			loading={options === null}
			showClear
			value={filters.kind}
			onChange={handleKindChange}
			pt={formFieldStylesPt}
		/>
	);
};

export default KindFilter;
